declare namespace $ {

	type $mol_text__text_shm_hitalama_map_widget_float_text_md_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text_md['text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_hitalama_map_widget_float_text_md extends $shm_hitalama_map_widget_float {
		text( ): string
		Md( ): $mol_text
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=md.view.tree.d.ts.map